<script setup lang="ts"></script>

<template>
	<a class="inline-flex items-center" href="/" aria-label="Home">
		<!-- логотип RStake -->
		<img src="/src/shared/assets/icons/main-logo.svg" class="w-21.5 drop-shadow-logo" alt="" />
	</a>
</template>
